import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdRuleSetResultByRuleSetResultIdOptions } from '@onefootprint/fetch-dashboard';
import type { EntityOnboardingRuleSetResult } from '@onefootprint/request-types/dashboard';
import { Shimmer } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Subsection from '@/components/entity-onboarding-details/components/subsection';
import ErrorComponent from '@/components/error';
import useEntityId from '@/entities/components/details/hooks/use-entity-id';
import groupRuleResults from '@/entities/components/details/utils/group-rule-results';
import Content from './components/content';
import RulesToggle from './components/rules-toggle';
type OnboardingRulesProps = {
  ruleSetResults: EntityOnboardingRuleSetResult[];
};
const OnboardingRules = t0 => {
  const $ = _c(15);
  const {
    ruleSetResults
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "classicOnboardings.rules"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [showTriggeredRules, setShowTriggeredRules] = useState(true);
  const entityId = useEntityId();
  const ruleSetResultId = ruleSetResults && ruleSetResults.length > 0 ? ruleSetResults[0].id : "";
  let t2;
  if ($[1] !== entityId || $[2] !== ruleSetResultId) {
    t2 = getEntitiesByFpIdRuleSetResultByRuleSetResultIdOptions({
      path: {
        fpId: entityId,
        ruleSetResultId
      }
    });
    $[1] = entityId;
    $[2] = ruleSetResultId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = Boolean(entityId) && Boolean(ruleSetResultId);
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = {
      ...t2,
      enabled: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data,
    isPending,
    error
  } = useQuery(t4);
  const noRuleResults = !ruleSetResultId || data && data.ruleResults.length === 0;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = isTriggered => {
      setShowTriggeredRules(isTriggered);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleClick = t5;
  let t6;
  if ($[8] !== data || $[9] !== error || $[10] !== isPending || $[11] !== noRuleResults || $[12] !== showTriggeredRules || $[13] !== t) {
    t6 = <Subsection>{noRuleResults ? <p className="text-body-2 text-tertiary">{t(_temp)}</p> : <div className="flex flex-col items-start gap-4"><RulesToggle onClick={handleClick} />{data && <Content ruleResults={groupRuleResults(data.ruleResults)[showTriggeredRules ? "triggered" : "notTriggered"]} showTriggered={showTriggeredRules} />}{isPending && <Shimmer height="150px" width="100%" />}{error && <ErrorComponent error={error} />}</div>}</Subsection>;
    $[8] = data;
    $[9] = error;
    $[10] = isPending;
    $[11] = noRuleResults;
    $[12] = showTriggeredRules;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default OnboardingRules;
function _temp($) {
  return $.noRuleResults;
}